// This file is not published with the npm package
// Do NOT put code in here that will be depended upon by consumers of this package

import { type LegacyCredential } from './common.js'

export const username = 'username'
export const accountNumber = 'account-number'
export const password = 'password'
export const apiKey = 'api-key'
export const apiPassword = 'api-password'
export const enableSpotVolume = 'enable-spot-volume-rates'

type LegacyBillToKey =
  | 'billTo.address'
  | 'billTo.city'
  | 'billTo.state'
  | 'billTo.postalCode'
  | 'billTo.country'

type LegacyEngineKey =
  | 'clientId'
  | 'clientSecret'
  | 'legacyUsername'
  | 'legacyPassword'
  | 'legacyApiKey'

export type LegacyCredMapValue =
  | keyof LegacyCredential
  | LegacyBillToKey
  | LegacyEngineKey

export type LegacyCredMap<TCredType extends string> = Array<
  [TCredType, LegacyCredMapValue | null]
>

export const userPassMap: LegacyCredMap<'username' | 'password'> = [
  ['username', 'username'],
  ['password', 'password'],
]
